import { render } from "./SessionOverview.vue?vue&type=template&id=d472ea42&scoped=true"
import script from "./SessionOverview.vue?vue&type=script&lang=js"
export * from "./SessionOverview.vue?vue&type=script&lang=js"

import "./SessionOverview.vue?vue&type=style&index=0&id=d472ea42&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d472ea42"

export default script